/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = (rowType) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                STT
                <div className="button-action">
                  <button onClick={handleAdd} type="button">
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Loại phí
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tiểu mục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Đơn vị tiền
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền phí thu được
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tỷ lệ trích để lại theo chế độ (%)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền phí trích để lại theo chế độ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền phí phải nộp NSNN
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7) = (4) - (6)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button onClick={() => handleDelete(item.id)} type="button">
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value2", value: e.target.value })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value3", value: e.target.value })
                    }
                  >
                    <option value="value1">VND</option>
                    <option value="value2">USD</option>
                  </select>
                </Td>

                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}

            <Td
              rowSpan={1}
              colSpan={7}
              style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}
            >
              Tổng cộng (theo đơn vị tiền)
            </Td>
            <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
              0
            </Td>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
            Thêm dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
